import React from 'react';
import {
    useSelectIsLayoutDirty,
    useSelectLayoutManualSave,
} from 'layout/store/selectors';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import classNames from 'classnames';
import { usePersistDirtyLayout } from 'layout/store/hooks';
import { Tooltip } from '@instinet-analytics/core-lib';
import './LayoutSaveButton.scss';

export interface LayoutSaveButtonProps {
    className?: string;
}

export function LayoutSaveButton(props: LayoutSaveButtonProps) {
    const isManualSave = useSelectLayoutManualSave();
    const isDirty = useSelectIsLayoutDirty();
    const persist = usePersistDirtyLayout();

    if (!isManualSave) {
        return <></>;
    }

    const onClickSave = () => {
        persist();
    };

    const tooltip = isDirty ? 'Save Layout' : 'Layout Saved';

    const cssClasses = classNames(
        'LayoutSaveButton',
        isDirty && 'is-dirty',
        props.className
    );

    return (
        <div className={cssClasses} onClick={onClickSave}>
            <Tooltip text={tooltip} showDelay={1}>
                <Icon name="save" />
            </Tooltip>
        </div>
    );
}
